import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import MyInput from '../../components/ui/MyInput';
import './extra.css';
import MyTextarea from '../../components/ui/MyTextarea';
import PrimaryButton from '../../components/ui/PrimaryButton';
import MyUploadMediaInput from '../../components/ui/MyUploadMediaInput';
import SelectRadio from '../../components/ui/SelectRadio';
import MarketingPhone from '../../components/ui/MarketingPhone';
import { RadioGroup, Radio } from '@nextui-org/react';
import MyDatePicker from '../../components/ui/MyDatePicker';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import LayeredDashboard from '../LayeredDashboard';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import { Calendar } from 'primereact/calendar';
import { useDispatch } from 'react-redux';
import CreateAction from '../../components/operational/createAction';
import systemSlice from '../../redux/systemSlice';
import allTabs from '../DashboardTabs';
import { ToggleButton } from 'primereact/togglebutton';
import Toggle from '../ThemeScreen/DnDNew/components/DnDItems/DnDSidebarItems/Inputs/Toggle';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { translate } from '../../utils/language';
import { v4 as uuid } from 'uuid';
import AbondonedCartNotification from './AbondonedCartNotification';
import useCustomNavigate from '../../components/operational/goBack';
import LayeredDashboardModal from './Modals/LayeredDashboardModal';
import countryCodes from '../../utils/countryCodes.json';

const countryOptions = countryCodes?.map(countryCode => {
  return { code: countryCode.iso2, name: countryCode.language, emoji: countryCode.emoji };
});

const tags = {
  header: ['{{firstName}}', '{{lastName}}'],
  description: ['{{firstName}}', '{{lastName}}'],
};
const options = [
  { name: '1 Saat', code: '1' },
  { name: '2 Saat', code: '2' },
  { name: '3 Saat', code: '3' },
  { name: '6 Saat', code: '6' },
  { name: '10 Saat', code: '10' },
  { name: 'Manuel Zaman Belirle', code: 'custom' },
];
const emptyNotification = {
  body: 'Sepetinizdede Ürün Bıraktınız!',
  title: 'Stoklarda tükenmeden hemen satın alın!',
  language: 'tr',
};
const emptyAutomation = {
  id: '',
  name: 'SEPET HATIRLATMA',
  type: 'ABONDONED_CART',
  data: {
    in: {
      seconds: 0,
    },
    notification: [
      {
        body: '',
        title: '',
        language: 'tr',
      },
    ],
  },
  isShow: true,
};
const AbondonedCart = ({ tab }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();
  const goBack = useCustomNavigate(tab);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [languageOptions, setLanguageOptions] = useState();
  const [idArray, setIdArray] = useState([]);

  const getAbondonedCartAutomations = async languageOptionData => {
    const response = await CreateAction({
      method: 'get',
      path: '/automations/ABONDONED_CART',
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response.error) return;
    const automations = response?.result?.resultData;
    if (automations?.length === 0) return;
    const newSelectedValues = [];
    const newSelectedNotifications = [];
    const newIdArray = [];
    const newSelectedItems = automations
      ?.sort((a, b) => {
        const indexA = a.data.order;
        const indexB = b.data.order;
        return indexA - indexB;
      })
      ?.map((automation, index) => {
        const seconds = automation?.data?.in?.seconds;
        const notification = automation.data.notification || [];
        const hours = Math.ceil(seconds / 60 / 60);
        const item = options.find(option => option.code == hours) || options.find(option => option.code === 'custom');
        newSelectedValues.push(item?.code === 'custom' ? hours : item?.code);
        newSelectedNotifications.push(
          notification
            ? notification
            : languageOptionData?.map(item => ({ ...emptyNotification, language: item.code, id: uuid() })),
        );
        newIdArray.push(automation.id);
        return item;
      });
    setIdArray(newIdArray);
    setSelectedItems(newSelectedItems);
    setSelectedValues(newSelectedValues);
    setSelectedNotifications(newSelectedNotifications);
    setIsActive(true);
  };

  const getLanguageAndRegions = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/getLocalizations`,
      showPreLoader: true,
      isFileUploading: false,
    });
    if (!response.result.resultData) return;
    let optionData = [];
    const languageAndRegions = response?.result.resultData;
    try {
      const optionDataObject = {};

      languageAndRegions?.forEach(childTheme => {
        const ThemeVariant = childTheme.ThemeVariant;
        optionDataObject[ThemeVariant.id] = {
          code: ThemeVariant.id,
          name: ThemeVariant.name,
          index: ThemeVariant?.index,
        };
      });
      const optionData = Object.values(optionDataObject)
        ?.filter(d => d)
        ?.sort((a, b) => {
          const indexA = a.index;
          const indexB = b.index;
          return indexA - indexB;
        })
        ?.sort((a, b) => {
          const nameA = a.name;
          const nameB = b.name;
          return nameA.localeCompare(nameB);
        });
      setLanguageOptions(optionData || []);
    } catch (e) {}

    getAbondonedCartAutomations(optionData);
  };

  useEffect(() => {
    getLanguageAndRegions();
  }, []);
  const saveAutomation = async () => {
    const automations = selectedValues.map((value, index) => {
      const notification = selectedNotifications[index];
      return {
        ...emptyAutomation,
        data: { in: { seconds: value * 60 * 60 }, notification: notification, order: index },
        id: idArray[index] || uuid(),
      };
    });
    const response = await CreateAction({
      method: 'post',
      path: '/createautomation',
      showPreLoader: true,
      isFileUploading: false,
      data: isActive ? automations : [],
    });

    if (response.error) return;
    goBack();
  };

  const setSelectedItem = (index, selection) => {
    setSelectedItems(state => {
      const prevState = [...state];
      prevState[index] = selection;
      prevState.id = prevState.id || uuid();
      return prevState;
    });
    if (selection.code !== 'custom') {
      setSelectedValues(state => {
        const prevState = [...state];
        prevState[index] = selection.code;
        return prevState;
      });
    }
  };

  const addSelectedItem = () => {
    setSelectedItems(state => {
      const prevState = [...state];
      prevState.push(options[0]);
      prevState.id = prevState.id || uuid();
      return prevState;
    });
    setSelectedValues(state => {
      const prevState = [...state];
      prevState.push(options[0].code);
      return prevState;
    });
    setSelectedNotifications(state => {
      const prevState = [...state];
      prevState.push(languageOptions?.map(item => ({ ...emptyNotification, language: item.code, id: uuid() })));
      return prevState;
    });
    setIdArray(state => {
      const prevState = [...state];
      prevState.push(uuid());
      return prevState;
    });
  };

  const removeSelectedItem = index => {
    setSelectedItems(state => {
      const prevState = [...state];
      return prevState.filter((item, i) => i !== index);
    });
    setSelectedValues(state => {
      const prevState = [...state];
      return prevState.filter((item, i) => i !== index);
    });
    setSelectedNotifications(state => {
      const prevState = [...state];
      return prevState.filter((item, i) => i !== index);
    });
    setIdArray(state => {
      const prevState = [...state];
      return prevState.filter((item, i) => i !== index);
    });
  };

  return (
    <>
      <LayeredDashboardHeader onSave={saveAutomation} tab={tab}></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex-col flex justify-center items-center">
            <div className="bg-white flex flex-row p-[20px] max-w-[1120px]  w-[100%] rounded-[10px] justify-start items-center">
              <div className="flex-col w-auto">
                <div className="text-[15px] h-[30px]">Sepet Hatırlatma Bildirimleri</div>
                <div className="text-[#8A92A6] text-[12px]">
                  Ödemeyi tamamlamadan sepeti terkeden müşterileri push notification ile bilgilendirin.
                </div>
              </div>
              <div className="ml-auto">
                <Toggle
                  setItem={value => {
                    setIsActive(value);
                  }}
                  value={isActive}
                  id={''}
                  targetKey={'abondonedCart'}
                  componentType={'toggle'}
                  hideBorder={true}
                  isWidgetItem={true}
                  className={'!p-0 display-flex justify-between'}
                  toggleClass={'!ml-[2px]'}
                ></Toggle>
              </div>
            </div>
            {isActive && (
              <div className="bg-white mt-[20px] flex flex-col max-w-[1120px] py-[20px]  w-[100%] rounded-[10px] justify-start items-center">
                <div className="border-b-2 border-b-[#F8F8F8] w-full px-[20px] flex flex-row pb-[20px]">
                  <div className="flex-col w-auto">
                    <div className="text-[15px] h-[30px]">Ayarlar</div>
                  </div>
                  <div className="ml-auto">
                    <SecondaryButton
                      onClick={() => {
                        addSelectedItem();
                      }}
                      value={'Akış Ekle'}
                    ></SecondaryButton>
                  </div>
                </div>
                <div className="flex flex-col w-full px-[20px]">
                  {selectedItems?.map((item, index) => {
                    return (
                      <div className="flex flex-row w-full min-h-full ">
                        <div className="h-auto flex flex-col relative w-[40px] pt-[12px] items-center">
                          <div className="rounded-full w-[15px] h-[15px] bg-white border-[5px] border-[#7059ef] shrink-0 "></div>
                          {selectedItems?.length - 1 !== index && (
                            <div className="h-auto min-h-full bg-[#8A92A6] bg-opacity-70 w-[3px]"></div>
                          )}
                        </div>
                        <div className="flex flex-col py-3">
                          <div className="text-[12px] text-[#8A92A6]">
                            Sepet terkedildikten ne zaman sonra push notification gönderileceğini belirle
                          </div>
                          <div className="flex flex-row items-center gap-[15px] py-3">
                            <Dropdown
                              options={options}
                              value={selectedItems[index]}
                              optionLabel="name"
                              onChange={e => setSelectedItem(index, e.value)}
                              placeholder="Seçiniz."
                              className="w-full h-[45px]"
                            ></Dropdown>
                            {selectedItems[index].code === 'custom' && (
                              <MyInput
                                type={'number'}
                                value={selectedValues[index] || ''}
                                onChange={value => {
                                  let setValue = Math.ceil(value);
                                  if (Number(setValue) < Number(0)) {
                                    setValue = 0;
                                  }

                                  if (setValue > 100) {
                                    setValue = 100;
                                  }

                                  setSelectedValues(state => {
                                    const prevState = [...state];
                                    prevState[index] = setValue;
                                    return prevState;
                                  });
                                }}
                              ></MyInput>
                            )}
                          </div>
                        </div>
                        <div className="flex flex-row ml-auto gap-[10px] items-center">
                          {selectedItems?.length > 1 && (
                            <SecondaryButton
                              classes="!h-[45px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white duration-300"
                              value={'Sil'}
                              onClick={() => {
                                removeSelectedItem(index);
                              }}
                            ></SecondaryButton>
                          )}
                          <PrimaryButton
                            classes="!h-[45px] duration-300"
                            value={'Bildirimi Düzenle'}
                            onClick={() => {
                              setActiveIndex(index);
                            }}
                          ></PrimaryButton>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <LayeredDashboardModal isActive={activeIndex !== false}>
        <AbondonedCartNotification
          languageOptions={languageOptions}
          setLanguageOptions={setLanguageOptions}
          setSelectedNotifications={setSelectedNotifications}
          selectedNotifications={selectedNotifications}
          activeIndex={activeIndex}
          setIsActive={setActiveIndex}
          tab={{
            ...tab,
            activeTabs: [...tab?.activeTabs, 'Bildirimi Düzenle'],
            activeTabTitles: [...tab?.activeTabTitles, 'Bildirimi Düzenle'],
          }}
        ></AbondonedCartNotification>
      </LayeredDashboardModal>
    </>
  );
};

export default AbondonedCart;
